import type { Country } from '../../../constants';

export type AddressData = {
  address1: string;
  address2?: string;
  city: string;
  state: string;
  postcode: string;
  country: Country;
};

export type NormalizeAddressRequest = {
  address: AddressData;
};

export type NormalizeAddressResponse = {
  original: AddressData;
  suggestions: AddressData[];
};
